import { useState, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import { CMM } from '../../Lib/Cmm.js';
import axios from 'axios';

import {
  Card,
  CardBody,
  Input,
  Col,
} from "reactstrap";
import { BorderTop } from "@material-ui/icons";
import { faL } from "@fortawesome/free-solid-svg-icons";

const Membership = () => {

  const navigate = useNavigate();

  const [page, setPage] = useState([1]);

  const [consent1, setConsent1] = useState(false);
  const [consent2, setConsent2] = useState(false);

  const [phone, setPhone] = useState('');
  const [num, setNum] = useState('');
  const [numOK, setNumOK] = useState(true);
  const [comp_nm, setCompNm] = useState('');
  const [nm, setNm] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rePassword, setRePassword] = useState('');



  const consentCheck = useCallback(() => {
    // if (consent1 && consent2) {
    //   setPage(2);
    // }
    if (consent1) {
      setPage(2);
    }
    else {
      toast.error('약관 동의가 필요합니다.', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: {
          marginTop: '500px'
        }
      });
    }
  }, [consent1]);


  const membershipIn = useCallback(() => {

    if (numOK && comp_nm && nm && email && password && password == rePassword) {
      userAdd();
    }
    else {

      if (!numOK) {
        toast.error('인증번호가 확인되지 않았습니다.', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: {
            marginTop: '100px'
          }
        });
      }
      else if (!comp_nm) {
        toast.error('기업명을 입력하세요.', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: {
            marginTop: '100px'
          }
        });
      }
      else if (!nm) {
        toast.error('사용자명을 입력하세요.', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: {
            marginTop: '100px'
          }
        });
      }
      else if (!email) {
        toast.error('이메일을 입력하세요.', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: {
            marginTop: '100px'
          }
        });
      }
      else if (password == '') {
        toast.error('비밀번호를 입력하세요.', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: {
            marginTop: '100px'
          }
        });
      }
      else if (password && password != rePassword) {
        toast.error('비밀번호를 다시 확인하세요.', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: {
            // marginTop: '500px'
          }
        });
      }

    }
  }, [numOK, comp_nm, nm, email, password, password, rePassword]);

  const userAdd = useCallback(() => {

    axios.post(`${CMM.SERVER_URL_API}/admin/user_add`,
      {
        comp_nm: comp_nm,
        user_nm: nm,
        email: email,
        pwd: password,
      })
      .then((res) => {
        if (res != 'ERROR') {
          //토스트 메시지
          // toast.success('성공적으로 변경되었습니다.', {
          //   position: "bottom-center",
          //   autoClose: 3000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: false,
          //   draggable: true,
          //   progress: undefined,
          //   theme: "light",
          // });
          console.log('resresres', res);
          setPage(3);

        }
      })
      .catch((e) => {
        console.log('error', e);
        return 'ERROR';
      })

  }, [comp_nm, nm, email, password]);

  const loingCheck = useCallback(() => {

    //계정 정보 확인
    axios.get(`${CMM.SERVER_URL_API}/loing/loing?email=${email}&password=${password}`)
      .then((res) => {
        if (res !== 'ERROR') {

          //계정 정보가 존재하지 않을 때
          if (res.data.message == '') {
            console.log("회원가입 실패");
          }
          else {

            const user_idx = res.data.message[0].user_idx;
            const u_uuid = res.data.message[0].u_uuid;

            // console.log(user_idx);
            // console.log(u_uuid);

            //세션 스토리지에 데이터 저장
            sessionStorage.setItem('user_idx', user_idx);
            sessionStorage.setItem('u_uuid', u_uuid);

            navigate("/admin/chatbot-start");

          }
        }
      })
      .catch((e) => {
        console.log('error', e);
      });
  }, [email, password]);

  return (
    <>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <Card className="bg-secondary shadow border-0 w-75"
        style={{ height: '900px' }}>
        <CardBody className="px-lg-5 py-lg-5">
          <div className="text-center text-muted mb-4 ">
            <div className="row flex justify-content-between px-6">
              <div>
                <div className=" font-weight-bold  text-md"
                  style={{ color: `${page == 1 ? '#0D6EFD' : '#242424'} `, }}>
                  <div>1</div>
                  <div>약관 동의</div>
                </div>
              </div>
              <div className="mt-2">
                <svg width="16" height="23" viewBox="0 0 16 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 2L13 12.7707L2 21" stroke="#535353" strokeWidth="3" />
                </svg>
              </div>
              <div>
                <div className=" font-weight-bold  text-md"
                  style={{ color: `${page == 2 ? '#0D6EFD' : '#242424'} `, }}>
                  <div>2</div>
                  <div>회원 정보 입력</div>
                </div>
              </div>
              <div className="mt-2">
                <svg width="16" height="23" viewBox="0 0 16 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 2L13 12.7707L2 21" stroke="#535353" strokeWidth="3" />
                </svg>
              </div>
              <div>
                <div className=" font-weight-bold  text-md"
                  style={{ color: `${page == 3 ? '#0D6EFD' : '#242424'} `, }}>
                  <div>3</div>
                  <div>회원가입 완료</div>
                </div>
              </div>

            </div>
            <div className="mt-3" style={{ height: "1px", backgroundColor: '#535353' }} >
            </div>
          </div>
          {
            page == 1 ?
              <div>
                <div className=" font-weight-bold"
                  style={{ color: '#404040' }}>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-1 mr-1">
                    <g clipPath="url(#clip0_198_2)">
                      <path d="M6.75005 12.15L3.60005 8.99995L2.55005 10.05L6.75005 14.25L15.75 5.24995L14.7 4.19995L6.75005 12.15Z" fill="black" />
                    </g>
                    <defs>
                      <clipPath id="clip0_198_2">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  이용약관
                  <div className=" bg-white px-3 py-2 rounded-lg mt-1 overflow-auto"
                    // style={{ height: '280px' }}>
                    style={{ height: '600px' }}>
                    <div className="text-sm mb-3" style={{ color: '#5F5F5F' }}>시행일자:2024년 03월 01일</div>
                    <div style={{ color: '#444444' }}>제 1 장 총칙</div>
                    <pre className="mx-3 mt-1 font-weight-bold text-sm" style={{ color: '#727272', whiteSpace: 'pre-line' }}>
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 1 조 (목적)</span> <br />
                      이 약관은 주식회사 (주)더클랩(이하 “회사”라 합니다)이 제공하는 챗봇 제작 및 채팅상담 플랫폼 박대리 활용과 관련하여 회사와 서비스를 이용하는 개인 또는 법인 간의 권리, 의무 및 책임 기타 필요한 사항을 규정함을 목적으로 합니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 2 조 (용어의 정의)</span> <br />
                      1. 이 약관에서 사용되는 용어의 정의는 다음과 같습니다. <br />
                      가. “서비스”는 고객이 자신의 웹사이트, SNS, 애플리케이션, 메시지 앱 등에 연동되는 챗봇을 생성하고 채팅상담에 활용할 수 있도록 회사가 고객에게 제공하는 챗봇 제작 및 채팅상담 플랫폼 박대리를 의미합니다. <br />
                      나. “챗봇”은 미리 정의된 규칙 또는 인공지능, 빅데이터 분석을 통하여 사용자의 질문에 답하는 대화형 메신저를 의미합니다. <br />
                      다. “고객”은 회사와 이용계약을 체결하고 서비스를 이용하는 개인 혹은 법인을 의미합니다. <br />
                      라. “사용자”는 고객이 서비스를 이용하여 생성한 챗봇을 통하여 고객과 대화하는 이용자를 의미합니다. <br />
                      마. “사이트”는 회사가 서비스를 위하여 운영하는 웹사이트(www.)를 의미합니다. <br />
                      바. “계정”은 서비스 이용을 위하여 사이트에서 생성된 고객의 로그인 계정을 의미합니다. <br />
                      사. “이용계약”은 서비스의 제공 및 이용과 관련하여 이 약관의 내용에 따라 고객과 회사가 합의하여 체결하는 계약을 의미합니다. <br />
                      아. “이용요금”은 고객이 서비스 이용의 대가로 회사에 지급하는 금원을 의미합니다. <br />
                      2. 이 약관에서 사용하는 용어의 정의는 제1항 각 호에서 정하는 것을 제외하고는 관계 법령 및 개인정보처리방침, 회사가 별도로 정한 지침 기타 일반적인 상관례에 의합니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 3 조 (약관의 효력 범위)</span> <br />
                      이 약관은 고객이 약관에 동의하여 회사와 이용계약을 체결한 날로부터 이를 해지하는 날까지 적용됩니다. 단, 이 약관의 일부 조항은 이용계약이 종료한 이후에도 효력이 계속될 수 있습니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 4 조 (회사의 기본정보)</span> <br />
                      회사의 기본정보는 다음의 각 호와 같습니다. <br />
                      가. 상호: 주식회사 더클랩 <br />
                      나. 주소: 서울특별시 서대문구 이화여대길 52, 127B (대현동, 이화여자대학교) <br />
                      다. 대표자: 신용필 <br />
                      라. 사업자등록번호: 615-86-17501 <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 5 조 (약관의 명시 및 개정)</span> <br />
                      1. 회사는 고객이 쉽게 알 수 있도록 사이트에 이 약관의 내용을 게시합니다. <br />
                      2. 회사는 고객이 약관에 동의하기에 앞서 약관의 내용 중 계약 해지, 회사의 면책사항 및 고객에 대한 배상 또는 보상 등과 같은 중요한 내용을 쉽게 이해할 수 있도록 해당 내용을 굵은 글씨 등으로 처리하거나 이에 관한 별도의 연결화면 또는 팝업화면 등을 제공합니다. <br />
                      3. 회사는 『약관의 규제에 관한 법률』, 『정보통신망 이용촉진 및 정보 보호 등에 관한 법률』 등 관련 법령을 위반하지 않는 범위에서 이 약관을 수시로 개정할 수 있습니다. <br />
                      4. 회사는 약관을 개정하는 경우 적용일자 및 개정사유를 개정 전 약관과 함께 적용일자 7일 전(고객에게 불리하거나 중대한 사항의 변경은 30일 이전)부터 사이트에 게시하는 방법으로 고객에게 통지합니다. <br />
                      5. 회사는 전항에 따라 개정 약관을 공지 또는 통지하면서 그와 함께 고객이 개정 약관의 효력 발생일까지 그에 대한 거부의 의사표시를 하지 않으면 개정약관에 승낙한 것으로 간주하겠다는 내용을 공지할 수 있습니다. 이러한 공지가 이루어진 경우, 고객이 개정 약관의 효력발생일까지 그에 대한 거부의사를 표시하지 않거나 탈퇴하지 않으면 그 고객은 청약철회 등 개정약관에 정한 모든 내용에 대하여 동의한 것으로 간주됩니다. <br />
                      6. 회사는 개정 약관의 적용에 동의하지 않는 고객에 대하여 개정 약관의 내용을 적용할 수 없습니다. 이 경우 회사 및 고객은 이용계약을 해지할 수 있습니다. <br />
                      7. 개정된 약관은 원칙적으로 그 효력 발생일(적용일자)로부터 장래를 향하여 유효합니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 6 조 (개별 서비스 및 약관 외 준칙)</span> <br />
                      1. 회사는 서비스의 구체적인 내용에 따라 이 약관과 별도로 고객의 동의를 얻어 개별 서비스에 대한 이용조건을 정할 수 있습니다. <br />
                      2. 이 약관에 정하지 않은 사항에 대하여는 개인정보처리방침, 관련 법령 또는 상관례에 따릅니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 7 조 (정보의 통지)</span> <br />
                      1. 회사는 고객이 제공한 전자우편주소로 전자우편을 전송하는 방법을 통하여 고객에게 필요한 정보를 통지할 수 있습니다. <br />
                      2. 회사는 불특정 다수 고객에 대한 통지의 경우, 사이트에 7일 이상의 기간 동안 그 통지를 게시하는 방법으로 제1항의 통지를 갈음할 수 있습니다. 다만, 특정 고객과의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 제1항에 따라 개별적으로 통지를 하여야 합니다. <br />
                      <br />
                      <br />
                      제 2 장 서비스 이용 <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 8 조 (이용계약의 체결)</span> <br />
                      1. 서비스를 이용하고자 하는 자(이하 “서비스 이용신청자”)는 사이트에서 회원가입시 이 약관에 대하여 ‘동의합니다’를 클릭하는 것으로 이 약관에 동의하는 의사표시를 하고, 회사가 요청하는 인적사항 및 이용하고자 하는 서비스의 유형에 대한 정보의 제공과 함께 서비스의 이용을 신청합니다. 서비스 이용신청자 본인이 아닌 대리인이 본인을 대리하여 이 약관에 대해 동의하는 경우, 대리인은 자신에게 그에 대한 적법한 대리권이 있음을 진술하고 보증합니다. <br />
                      2. 회사는 원칙적으로 제1항의 신청을 승인하여 서비스 이용신청자와 이용계약을 체결합니다. 다만, 회사는 서비스 이용신청자에게 다음 각 호의 사유가 존재하는 경우 이용계약의 체결을 거절할 수 있으며, 사후적으로 고객에게 다음 각 호의 사유가 존재함을 안 경우 그 고객과의 이용계약을 해지할 수 있습니다. <br />
                      가. 타인의 명의를 도용하여 가입신청을 한 경우 <br />
                      나. 서비스 이용신청과 관련하여 허위의 또는 부정확한 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우 <br />
                      다. 만14세 미만이거나, 만 14세 이상 만 19세 미만의 미성년자가 법정대리인의 동의를 얻지 못한 경우 <br />
                      라. 거주하는 국가가 서비스를 제공받을 수 없는 국가인 경우 <br />
                      마. 기타 제반 규정 위반 등 귀책사유로 인하여 회사가 서비스의 제공을 거절할 만한 객관적인 사유가 존재하는 경우 <br />
                      3. 회사는 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 이용계약의 체결을 유보할 수 있습니다. 이 경우, 회사는 문제 해결을 위하여 노력합니다. <br />
                      4. 이용계약 체결에 따라, 서비스 이용신청자는 고객의 지위에서 회사가 제공하는 서비스를 이용할 수 있습니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 9 조 (서비스 종류 및 이용요금)</span> <br />
                      1. 고객은 회사로부터 제공받는 서비스의 종류 및 그 규모에 따라, 회사에게 이용료 안내페이지에 게재한 바에 따른 이용요금을 지급합니다. <br />
                      2. 회사는 사이트에 제1항의 이용요금 산정기준을 게시합니다. 또한, 본 조에서 정하지 않은 이용요금 관련 세부사항은 사이트에 게시된 바에 따릅니다. <br />
                      3. 회사는 제1항의 이용요금 산정기준을 변경하는 경우, 변경일로부터 적어도 30일 이전까지 사이트 게시, 이메일 또는 서면을 통한 방법으로 고객에게 해당 사항을 통지합니다. 위 변경 내지 인상의 효력은 통지상에 명기한 변경일로부터 유효하게 발생하며, 위 변경에 동의하지 않는 고객은 이용계약을 해지할 수 있습니다. <br />
                      4. 고객은 회사와의 별도 합의를 통하여 본 조와 다른 내용으로 이용요금에 관한 사항을 정할 수 있습니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 10 조 (서비스 제공)</span> <br />
                      1. 회사는 관련 법령상 허용되는 그리고 기술적으로 가능한 범위 내에서 서비스를 제공합니다. <br />
                      2. 회사는 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 1일 24시간 고객에게 서비스를 제공합니다. 다만 회사는 정기 점검 등의 필요가 있는 경우 일정 기간 동안 서비스의 제공을 제한할 수 있으며, 이 경우 회사는 이러한 사실을 고객에게 사전 통지합니다. <br />
                      3. 회사는 서비스의 이용 가능한 시간을 별도로 정할 수 있으며 이 경우 그 내용을 고객에게 사전에 통지합니다. 단, 회사가 통제할 수 없는 사유로 발생한 서비스 중단에 대하여 사전 통지가 불가능한 경우에는 이를 사후에 통지할 수 있습니다. <br />
                      4. 회사는 개인정보 보호법 등 관계 법령에 위반되지 않는 범위 내에서 서비스의 원활한 제공, 통계에의 활용, 서비스 유지 및 개발의 목적으로 고객이 서비스를 이용하는 과정에서 발생하는 데이터(챗봇과 챗봇 사용자 사이의 대화 내용 및 관련 정보, 이하 “데이터”)를 고객으로부터 제공 받아 수집, 보관, 가공, 이용 기타 처리할 수 있습니다. <br />
                      5. 고객은 제4항의 데이터 제공이 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』기타 관련 법령에 따라 적법하게 이루어지는 것임을 보증하며, 이를 위하여 챗봇 사용자로부터 개인정보의 제3자 제공에 대한 동의를 받는 등 법령상 필요한 조치를 취하여야 합니다. 본 항을 위반하여 회사에 손해가 발생하는 경우, 고객은 자신의 비용 및 책임으로 회사를 면책하여야 합니다. <br />
                      6. 고객이 자신의 SNS 페이지 기타 제3자의 플랫폼을 이용하여 서비스를 이용하는 경우, 고객은 회사가 서비스 제공을 위하여 필요한 범위 내에서 해당 SNS 페이지 기타 플랫폼에 대한 접근, 관리 및 이용 권한을 가지는 것에 동의하며, 그에 따라 회사에게 위 접근, 관리 및 이용 권한을 부여합니다. 고객이 이러한 권한 부여를 거부하거나 사후적으로 철회하는 경우, 서비스의 전부 또는 일부 이용이 제한될 수 있습니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 11 조 (서비스의 이용 제한)</span> <br />
                      1. 회사는 고객이 제15조의 의무 및 기타 이 약관상 의무를 위반하는 경우, 해당 고객에 대하여 다음 각 호의 이용제한 조치를 단계적으로 취할 수 있습니다. <br />
                      가. 시정요구 <br />
                      나. 일시정지 <br />
                      다. 영구이용정지 <br />
                      2. 본 조의 이용제한 조치에 관한 조건 및 세부내용은 회사의 이용제한정책 및 개별 서비스상의 운영정책을 통하여 정합니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 12 조 (서비스의 변경 및 중단, 종료)</span> <br />
                      1. 회사는 다음 각 호의 경우 제공하는 서비스의 전부 또는 일부를 일시적으로 변경하거나 중단할 수 있습니다. <br />
                      가. 설비의 보수점검, 교체 등 공사로 인하여 부득이한 경우 <br />
                      나. 정전, 화재, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우 <br />
                      다. 국가기관 또는 정부조직(방송통신위원회, 한국정보보호진흥원 등), 수사기관, 법원 등의 행정 또는 사법적 처분 등에 따라 법상 서비스의 제공을 제한 또는 중단하여야 하는 경우 <br />
                      라. 기타 회사의 운영상, 기술상 필요 등 상당한 이유가 있는 경우 <br />
                      2. 회사는 다음 각 호의 경우 서비스의 제공을 영구적으로 종료할 수 있습니다. <br />
                      가. 국가기관 또는 정부조직(방송통신위원회, 한국정보보호진흥원 등), 수사기관, 법원 등의 행정 또는 사법적 처분 등에 따라 법상 서비스의 제공을 종료하여야 하는 경우 <br />
                      나. 기타 경영상, 운영정책상, 기술상 사유 등으로 인하여 회사가 서비스 제공을 계속할 수 없는 상당한 이유가 있는 경우 <br />
                      3. 본 조에 따라 서비스를 변경 또는 중단(제2항의 종료 포함, 이하 같음)하는 경우, 회사는 사전에 다음 각 호의 사항을 제7조에 정한 방법으로 고객에게 통지하여야 합니다. 다만, 사전에 통지할 수 없는 부득이한 사유가 있는 경우 회사는 서비스의 제공을 변경 또는 중단하고 나서 사후적으로 고객에 대한 통지를 할 수 있습니다. <br />
                      가. 서비스 변경(또는 중단) 사유 <br />
                      나. 서비스 변경일(또는 중단일) <br />
                      다. 변경될 서비스의 내용(서비스 변경의 경우) <br />
                      4. 본 조에 따른 서비스의 변경 또는 중단과 관련하여, 회사는 관련 법령 또는 개별 계약상 명시적으로 규정된 범위 내에서 고객에 대하여 배상 또는 보상책임을 부담합니다. 유료 서비스를 이용한 고객의 경우, 회사는 서비스의 변경 또는 중단으로 인한 서비스 미사용 부분 관련 이용대금을 고객에게 환불합니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 13 조 (광고 기타 정보의 제공)</span> <br />
                      1. 회사는 서비스 이용과 관련한 정보를 제7조에 정한 방법으로 고객에게 제공할 수 있습니다. 고객은 관련 법령에 따른 거래관련 정보 및 고객문의 등에 대한 답변 등을 제외하고는 언제든지 회사가 제공하는 정보가 포함된 전자우편의 수신을 거절할 수 있습니다. <br />
                      2. 회사는 웹사이트, 애플리케이션, 메신저, 전자우편 등을 통하여 고객에게 마케팅 광고 등의 정보를 제공할 수 있습니다. 고객은 회사에 대한 의사표시로서 마케팅 광고에 대한 수신을 거절할 수 있습니다. <br />
                      <br />
                      <br />
                      제 3 장 계약 당사자의 권리 의무 <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 14 조 (회사의 일반 의무)</span> <br />
                      1. 회사는 고객에 대한 서비스 제공과 관련하여 관련 법령 및 이 약관, 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적인 서비스 제공을 위하여 최선을 다합니다. 다만, 회사는 서비스에 관하여 그 품질이나 성능, 상품성, 특정 목적에의 적합성 및 비침해 등에 대하여 명시적 또는 묵시적으로 보증하지는 아니합니다. <br />
                      2. 회사는 고객이 안전하게 서비스를 이용할 수 있도록 고객의 개인정보(신용정보 포함)를 보호하기 위하여 최선을 다하며, 개인정보처리방침을 공시하고 준수합니다. <br />
                      3. 회사는 서비스 이용과 관련한 고객의 불만 또는 피해구제요청을 적절하게 처리할 수 있도록 필요한 인력 및 시스템을 구축 및 유지할 수 있도록 최선을 다합니다. <br />
                      4. 회사는 서비스 이용과 관련하여 고객이 정당한 의견 또는 불만을 제기하는 경우, 이를 처리하고 이메일 등을 통하여 고객에게 그 처리과정 및 결과를 신속하게 전달합니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 15 조 (고객의 일반 의무)</span> <br />
                      1. 고객은 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 아니 됩니다. <br />
                      가. 타인의 계정 정보 등을 도용하는 행위 <br />
                      나. 회사의 사전 승낙 없이 회사가 서비스 상에 게시한 정보를 변경 또는 삭제하는 행위 <br />
                      다. 회사의 지식재산권 기타 권리를 침해하는 행위 <br />
                      마. 서비스 운영을 고의로 방해하거나 서비스의 안정적 운영을 방해할 수 있는 정보를 전송하는 행위 <br />
                      바. 기타 법령 또는 약관에 위배되거나 부당한 행위 <br />
                      2. 고객은 서비스의 이용과 관련하여 관계 법령, 약관, 세부이용지침, 서비스 이용안내 및 회사가 통지한 공지사항 등을 준수하여야 하며, 기타 회사의 업무를 방해하는 행위를 하여서는 안됩니다. <br />
                      3. 고객은 회사의 사전 승낙 없이는 회사가 제공하는 서비스를 이용하여 회사의 영업과 동종의 또는 유사한 영업을 영위할 수 없습니다. <br />
                      4. 회사는 회사의 사전 승낙 없이 고객이 행한 제3항의 동종 유사 영업에 대하여 어떠한 책임도 부담하지 않으며, 고객의 위 영업으로 인하여 회사에게 손해가 발생한 경우 해당 고객은 회사가 입은 손해를 전액 배상하여야 합니다. <br />
                      5. 고객은 회사의 서비스를 이용하여 챗봇 사용자를 포함한 제3자의 개인정보를 수집하거나, 제3자의 개인정보를 회사를 포함한 다른 자에게 제공하는 경우, 『약관의 규제에 관한 법률』, 『정보통신망 이용촉진 및 정보 보호 등에 관한 법률』 등 관련 법령을 준수하여야 합니다. 회사는 고객이 위 관련 법령을 위반하는 경우 그에 대하여 어떠한 책임도 부담하지 않습니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 16 조 (고객의 계정 정보 관리에 대한 의무 및 책임)</span> <br />
                      1. 고객은 자신의 계정 정보가 제3자에 유출되지 않도록 안전하게 관리할 책임이 있으며, 고객은 자신의 계정 정보를 제3자가 이용하도록 하여서는 안됩니다 <br />
                      2. 고객은 제3자가 자신의 계정 정보 등 개인정보를 이용하고 있음을 인지한 경우 즉시 회사에 이러한 사실을 통지하고 이후 회사의 안내에 따라야 합니다. <br />
                      3. 고객이 본 조의 의무에 위반하여 발생한 불이익에 대하여, 회사는 어떠한 책임도 부담하지 않습니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 17 조 (지식재산권)</span> <br />
                      1. 회사가 서비스와 관련하여 고객에게 제공하는 일체의 정보 및 자료에 대한 특허권, 저작권 기타 일체의 지식재산권은 회사에게 있습니다. 회사가 고객에게 서비스를 제공하는 것은 본 약관에 정한 서비스 목적 하에서 회사가 허용한 방식으로 서비스에 대한 이용권한을 부여하는 것이며, 고객은 서비스를 소유하거나 서비스에 관한 저작권을 보유하게 되는 것이 아닙니다. <br />
                      2. 이 약관에 기한 서비스 이용 과정에서 발생하는 일체의 데이터 등 산출물에 대한 지식재산권은 고객에게 귀속하며, 고객은 위 데이터 등 산출물에 대한 무상 사용권을 회사에게 부여합니다. 이에 따라 회사는 위 데이터 등 산출물을 회사의 영업 목적을 위하여 무상으로 영구적으로 수집, 보관, 가공, 이용 기타 처리할 수 있습니다. 이용계약이 종료한 후에도 기존에 발생한 데이터 등 산출물에 관한 회사의 사용권은 유효하게 존속합니다. <br />
                      3. 고객은 서비스 이용과 관련하여 회사의 지식재산권을 침해하여서는 아니 됩니다. <br />
                      <br />
                      <br />
                      제 4 장 계약 해지 <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 18 조 (이용계약의 해지)</span> <br />
                      1. 회사 또는 고객은 해지 사유가 발생하는 경우 상대방에 대한 이메일 내지 서면 통지를 통하여 이용계약을 해지할 수 있습니다. <br />
                      2. 회사는 고객에게 다음 각 호의 사유가 존재하는 경우 사전 통지 후 이용계약을 해지할 수 있습니다. 단, 고객이 현행법 위반 및 고의 내지 중과실로 회사에 손해를 입힌 경우, 사전 통지 없이 해당 고객과의 이용계약을 해지할 수 있습니다. <br />
                      가. 제8조 제4항의 ‘승낙거절사유’가 존재하는 경우 <br />
                      나. 제9조의 이용요금을 ‘2개월분’ 이상 연체하는 경우 <br />
                      다. 제15조에 규정된 고객의 의무를 위반하고 회사로부터 시정요청을 받았음에도 ‘14’일 이내에 이를 시정하지 않는 경우 <br />
                      라. 기타 회사가 그 고객에 대한 서비스의 제공을 거부할 만한 합리적 사유가 존재하는 경우 <br />
                      3. 회사 또는 고객은 다음 각 호의 사유가 존재하는 경우 상대방에 대한 통지를 통하여 서비스 이용계약을 해지할 수 있습니다. <br />
                      가. 당사자 일방이 은행거래정지, 강제집행, 회생절차 개시 또는 파산선고 등의 부도사유가 발생한 경우 <br />
                      나. 당사자 일방이 기타 이 약관을 중대하게 위반하여 서비스 이용계약의 유지가 사실상 불가능한 경우 <br />
                      4. 제3항 또는 제4항에 따라 이용계약이 해지되는 경우, 회사는 제7조에 정한 방법으로 고객에게 다음 각 호의 사항을 통보합니다. <br />
                      가. 해지사유 <br />
                      나. 해지일 <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 19 조 (계약해지의 효과)</span> <br />
                      1. 이용계약의 효력은 당사자 일방이 상대방에게 이용계약 해지 통보를 한 때에 소멸하며, 고객은 이후 서비스를 이용할 수 없습니다. <br />
                      2. 본 조의 이용계약 해지에 따라, 회사는 관련 법령 및 개인정보처리방침 등에 따라 회사가 보유하여야 하는 정보를 제외한 고객 관련 정보를 삭제합니다. 단, 제10조 제4항 및 제17조에 정한 데이터 등 산출물 관련 정보는 예외로 합니다. <br />
                      3. 본 조의 해지는 제20조의 손해배상에 영향을 미치지 않습니다. <br />
                      <br />
                      <br />
                      제 5 장 기타 <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 20 조 (손해배상)</span> <br />
                      당사자 일방은 서비스의 제공 또는 이용과 관련하여 이 약관의 위반 등 책임 있는 사유로 상대방에게 손해를 입힌 경우, 상대방이 입은 손해를 배상하여야 합니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 21 조 (양도의 제한)</span> <br />
                      고객은 약관 및 이용계약에 따라 가지는 권리 및 계약상 지위를 제3자에게 양도, 판매, 담보제공 등 처분할 수 없습니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 22 조 (개인정보의 보호)</span> <br />
                      1. 회사는 이용계약을 위하여 고객이 제공한 개인정보를 회사의 서비스 운영을 위한 목적 이외의 용도로 사용하거나 고객의 동의 없이 제3자에게 제공하지 않습니다. 단, 다음 각 호의 경우에는 예외로 합니다. <br />
                      가. 법령에 근거하여 고객정보의 이용과 제3자에 대한 정보제공이 허용되는 경우 <br />
                      나. 기타 회사의 약관 및 정책에 따라 고객의 동의를 구한 경우 <br />
                      2. 개인정보의 보호 및 사용에 대해서는 관련 법령 및 회사의 개인정보처리방침이 적용됩니다. 회사가 서비스상 또는 웹사이트 게시판을 통하여 게재, 공시하는 개인정보처리방침은 약관의 일부를 구성하며 고객은 그 내용에 동의합니다. <br />
                      3. 회사는 수집된 개인정보의 처리 및 관리 등의 업무를 스스로 수행하는 것을 원칙으로 하나, 필요한 경우 업무의 일부 또는 전부를 제3자에게 위탁할 수 있습니다. 이와 관련한 제반 사항은 개인정보처리방침을 통하여 고객에게 고지, 안내합니다. <br />
                      4. 회사는 고객의 개인정보를 보호하기 위하여 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』 및 『개인정보 보호법』 등 관계 법령에서 정하는 바를 준수합니다. <br />
                      5. 회사는 고객의 귀책사유로 인하여 노출된 고객의 계정정보를 포함한 모든 정보에 대해서 일체의 책임을 지지 않습니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 23 조 (면책)</span><br />
                      1. 회사는 다음 각 호의 사유로 인하여 서비스를 원활하게 제공하지 못한 경우 이와 관련한 책임을 부담하지 않습니다. <br />
                      가. 전쟁, 천재지변, 해킹, 시스템 오류 기타 이에 준하는 불가항력이 발생한 경우 <br />
                      나. 회사가 제12조에 따라 서비스 변경 및 중단을 행하는 경우 <br />
                      다. 고객의 귀책 사유로 인하여 회사가 서비스를 정상적으로 제공하지 못한 경우 <br />
                      2. 회사는 회사가 제공하는 서비스 또는 광고를 매개로 하여 고객 간 또는 고객과 제3자(챗봇 사용자를 포함함) 사이에서 이루어진 거래 등에 대하여 어떠한 책임도 부담하지 않습니다. <br />
                      3. 고객은 회사의 서비스와 관련하여 제3자로부터 클레임(의무, 손해배상, 합의, 위약금, 벌금, 과태료 등 행정처분, 비용, 클레임 등을 포함하며, 이에 제한되지 아니합니다. 이하 “클레임 등”이라 합니다)이 발생하는 경우, 그로부터 회사를 면책하는 것에 동의합니다. 회사는 이 경우 고객에게 해당 클레임 등에 관한 내용을 서면으로 제공하며, 고객은 합리적인 범위 내에서 회사가 해당 클레임 등에 대한 방어권을 행사하는데 필요한 협조를 제공하여야 합니다. 회사는 고객에 의하여 면책되는 클레임 등에 대하여 특별 방어 및 통제에 대한 책임을 맡을 권리가 있습니다. 단, 해당 클레임 등에 대하여 회사에게 귀책사유가 있는 경우에 한하여 고객은 회사에 대하여 책임을 물을 수 있습니다. <br />
                      4. 회사는 고객의 행위로 인하여 고객 본인, 다른 고객 또는 제3자에게 발생한 손해 등에 대하여 어떠한 책임도 부담하지 않습니다. 고객의 귀책사유로 회사와 제3자 사이에 분쟁이 발생하는 경우, 고객은 자신의 비용과 책임으로 분쟁을 해결하며 이와 관련하여 발생한 회사의 의무 또는 책임(변호사 보수 지급 의무 등 포함)을 면책합니다. <br />
                      <br />
                      <span className="text-md" style={{ color: '#444444' }}>제 24 조 (분쟁의 해결)</span> <br />
                      1. 이 약관 및 이용계약에 관한 분쟁은 대한민국 법을 준거법으로 합니다. <br />
                      2. 이 약관 및 이용계약에 관하여 회사와 고객 사이에 발생한 분쟁에 관한 소송은 서울중앙지방법원을 제1심 관할법원으로 하여 해결합니다. <br />
                      <br />
                      <br />
                      부칙 <br />
                      제 1 조 (개정일) <br />
                      이 약관은 2024년 4월 0일부터 시행합니다. <br />

                    </pre>
                  </div>
                </div>
                <div className=" text-sm text-right my-2 mr-4 font-weight-bold "
                  onClick={() => setConsent1(!consent1)}
                  style={{ cursor: "pointer" }}>
                  <svg className="mb-1 mr-1" width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.81818 7.1194L0.954546 4.29851L0 5.23881L3.81818 9L12 0.940299L11.0455 0L3.81818 7.1194Z" fill={consent1 ? "#3094FF" : "#C9C9C9"} />
                  </svg>
                  동의
                </div>
                {/* <div className=" font-weight-bold "
                  style={{ color: '#404040' }}>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-1 mr-1">
                    <g clip-path="url(#clip0_198_2)">
                      <path d="M6.75005 12.15L3.60005 8.99995L2.55005 10.05L6.75005 14.25L15.75 5.24995L14.7 4.19995L6.75005 12.15Z" fill="black" />
                    </g>
                    <defs>
                      <clipPath id="clip0_198_2">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  개인정보 수집 및 이용
                  <div className=" bg-white px-3 py-2 rounded-lg mt-1 overflow-auto "
                    style={{ height: '280px' }}>
                    <div className="text-sm mb-3" style={{ color: '#5F5F5F' }}>시행일자:2024년 03월 01일</div>
                    <div>제 1 조 목적</div>
                    <p className="ml-3 mt-1 font-weight-bold text-sm" style={{ color: '#5F5F5F' }}>
                      이 계약("플랜")은 Apple Korea Limited.("Apple")(주소: 서울특별시 강남구 영동대로 517(우편번호 06164))가
                      상기 플랜에 따라 제공하는 서비스에 적용되며 이 문서의 조건, 귀하의 플랜 확인서("플랜 확인서"), 귀하 플랜의 판매
                      영수증 원본을 포함합니다. 플랜 확인서는 구입 시 제공되거나 이후에 귀하에게 자동으로 발송됩니다. 귀하가 플랜을
                      Apple로부터 구입한 경우 mysupport.apple.com/products 페이지를 방문하면 귀하의 플랜 확인서 사본을 얻을
                      수 있습니다.
                      이 플랜에 따른 혜택은 관련 법률에 따른 귀하의 권리, 제조업체의 하드웨어 보증, 일체의 무상 기술 지원 외에 추가적으로
                      제공됩니다. 이 플랜의 조건은 달리 명시하지 않는 한, 1회 기준 결제("일시불 플랜")이든 월 단위 결제("할부 플랜")이든
                      상관없이 동일하게 적용됩니다.
                      이 계약("플랜")은 Apple Korea Limited.("Apple")(주소: 서울특별시 강남구 영동대로 517(우편번호 06164))가
                      상기 플랜에 따라 제공하는 서비스에 적용되며 이 문서의 조건, 귀하의 플랜 확인서("플랜 확인서"), 귀하 플랜의 판매
                      영수증 원본을 포함합니다. 플랜 확인서는 구입 시 제공되거나 이후에 귀하에게 자동으로 발송됩니다. 귀하가 플랜을
                      Apple로부터 구입한 경우 mysupport.apple.com/products 페이지를 방문하면 귀하의 플랜 확인서 사본을 얻을
                      수 있습니다.
                      이 플랜에 따른 혜택은 관련 법률에 따른 귀하의 권리, 제조업체의 하드웨어 보증, 일체의 무상 기술 지원 외에 추가적으로
                      제공됩니다. 이 플랜의 조건은 달리 명시하지 않는 한, 1회 기준 결제("일시불 플랜")이든 월 단위 결제("할부 플랜")이든
                      상관없이 동일하게 적용됩니다.
                    </p>
                  </div>
                </div>
                <div className=" text-sm text-right my-2 mr-4 font-weight-bold "
                  onClick={() => setConsent2(!consent2)}
                  style={{ cursor: "pointer" }}>
                  <svg className="mb-1 mr-1" width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.81818 7.1194L0.954546 4.29851L0 5.23881L3.81818 9L12 0.940299L11.0455 0L3.81818 7.1194Z" fill={consent2 ? "#3094FF" : "#C9C9C9"} />
                  </svg>
                  동의
                </div> */}

                <div className="text-right mt-4"
                  onClick={consentCheck}
                  style={{ cursor: "pointer" }}>
                  <span className="p-2 rounded-sm font-weight-bold text-sm  "
                    style={{ backgroundColor: '#0D6EFD', color: '#ffffff' }}>
                    다음으로
                  </span>
                </div>

              </div> : ''
          }
          {
            page == 2 ?
              <div className=" text-center mt-5 ">
                <div className=" font-weight-bold"
                  style={{ color: '#404040' }}>
                  계정 만들기
                </div>
                <div className="row flex justify-content-center text-left">
                  <div className="mr-4">
                    {/* <div className="my-4">
                      <div className=" font-weight-bold"
                        style={{ color: '#404040', paddingBottom: '15px', paddingTop: '10px' }}>
                        연락처
                      </div>
                      <div className=" font-weight-bold"
                        style={{ color: '#404040', paddingBottom: '20px', paddingTop: '10px' }}>
                        인증번호 확인
                      </div>
                    </div> */}
                    <div className="my-4">
                      <div className=" font-weight-bold"
                        style={{ color: '#404040', paddingBottom: '15px', paddingTop: '10px' }}>
                        기업명
                      </div>
                      <div className=" font-weight-bold"
                        style={{ color: '#404040', paddingBottom: '15px', paddingTop: '10px' }}>
                        관리자 이름
                      </div>
                      <div className=" font-weight-bold"
                        style={{ color: '#404040', paddingBottom: '15px', paddingTop: '10px' }}>
                        이메일(ID)
                      </div>
                    </div>
                    <div className="my-4">
                      <div className=" font-weight-bold"
                        style={{ color: '#404040', paddingBottom: '15px', paddingTop: '10px' }}>
                        비밀번호
                      </div>
                      <div className=" font-weight-bold"
                        style={{ color: '#404040', paddingBottom: '20px', paddingTop: '10px' }}>
                        비밀번호 재확인
                      </div>
                    </div>
                  </div>
                  <div>
                    {/* <div className="my-4">

                      <div className="   ">
                        <Input
                          className="form-control-alternative mb-2 border shadow-none text-dark d-inline-block "
                          style={{ width: '250px' }}
                          value={phone}
                          value={handlePhoneChange(phone)}
                          placeholder="- 없이 숫자만 입력하세요."
                          onChange={(e) => {
                            setPhone(e.target.value);
                          }}
                        />
                        <span className=" mt-2 ml-2 "
                          onClick={numCheck}
                          style={{ cursor: "pointer" }}>
                          <span className="p-2 px-3 rounded-sm font-weight-bold text-sm  "
                            style={{ backgroundColor: '#0D6EFD', color: '#ffffff' }}>
                            번호발송
                          </span>
                        </span>
                      </div>
                      <div className="   ">
                        <div className="border  bg-white p-0 mb-2 rounded-lg d-inline-block "
                          style={{ width: '250px' }}>
                          <Input
                            className="form-control-alternative  shadow-none text-dark d-inline-block "
                            style={{ width: '200px' }}
                            value={num}
                            value={num}
                            placeholder="인증번호 입력"
                            onChange={(e) => {
                              setNum(e.target.value);
                            }}
                          />
                          <span className=" ml-2" style={{ color: '#2CAF0C' }}>3:00</span>
                        </div>
                        <span className=" mt-2 ml-2 "
                          onClick={numCheck}
                          style={{ cursor: "pointer" }}>
                          <span className="p-2 px-3 rounded-sm font-weight-bold text-sm  "
                            style={{ backgroundColor: '#0D6EFD', color: '#ffffff' }}>
                            인증하기
                          </span>
                        </span>
                      </div>
                    </div> */}
                    <div className="my-4">
                      <Input
                        className="form-control-alternative mb-2 border shadow-none text-dark "
                        style={{ width: '350px' }}
                        value={comp_nm}
                        type="text"
                        placeholder=""
                        onChange={(e) => {
                          setCompNm(e.target.value);
                        }}
                      />
                      <Input
                        className="form-control-alternative mb-2 border shadow-none text-dark "
                        style={{ width: '350px' }}
                        value={nm}
                        type="text"
                        placeholder=""
                        onChange={(e) => {
                          setNm(e.target.value);
                        }}
                      />
                      <Input
                        className="form-control-alternative mb-2 border shadow-none text-dark "
                        style={{ width: '350px' }}
                        value={email}
                        placeholder=""
                        type="text"
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                    </div>
                    <div className="my-4">
                      <Input
                        className="form-control-alternative mb-2 border shadow-none text-dark "
                        type="password"
                        style={{ width: '350px' }}
                        value={password}
                        placeholder=""
                        autoComplete="new-password"
                        onChange={(e) => {
                          setPassword(e.target.value);
                        }}
                      />
                      <Input
                        className="form-control-alternative mb-2 border shadow-none text-dark "
                        style={{ width: '350px' }}
                        type="password"
                        value={rePassword}
                        placeholder=""
                        onChange={(e) => {
                          setRePassword(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className=" mt-4"
                  onClick={membershipIn}
                  style={{ cursor: "pointer" }}>
                  <span className="py-2 rounded-sm font-weight-bold text-sm  "
                    style={{ backgroundColor: '#0D6EFD', color: '#ffffff', paddingLeft: "90px", paddingRight: "90px", }}>
                    계정 만들기
                  </span>
                </div>

              </div> : ''
          }
          {
            page == 3 ?
              <div className=" text-center "
                style={{ marginTop: '160px' }}>
                <div className=" font-weight-bold"
                  style={{ color: '#404040' }}>
                  가입이 완료되었습니다!
                </div>
                <div className=" mt-4"
                  onClick={() => {

                    loingCheck();

                  }
                  }
                  style={{ cursor: "pointer" }}>
                  <span className="p-2 rounded-sm font-weight-bold text-sm  "
                    style={{ backgroundColor: '#0D6EFD', color: '#ffffff' }}>
                    챗봇 시작하기
                  </span>
                </div>

              </div> : ''
          }
        </CardBody>
      </Card >


    </>
  );
};

export default Membership;